export const designTokens = {
    color: {
        background: '#080b12',
        surface0: '#0d111b',
        surface1: '#121828',
        surface2: '#192133',
        surface3: '#1f2a40',
        surfaceHighlight: 'rgba(148, 163, 184, 0.16)',
        borderSubtle: 'rgba(148, 163, 184, 0.18)',
        borderStrong: 'rgba(148, 163, 184, 0.32)',
        textPrimary: '#f8fafc',
        textSecondary: '#cbd5f5',
        textMuted: '#94a3b8',
        accent: '#7c5cff',
        accentMuted: '#a28dff',
        accentContrast: '#05070c',
        focus: '#38bdf8',
        success: '#22d3ee',
        warning: '#f97316',
        danger: '#f87171',
        overlay: 'rgba(8, 11, 18, 0.78)'
    },
    typography: {
        fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSizeXs: '12px',
        fontSizeSm: '13px',
        fontSizeMd: '15px',
        fontSizeLg: '17px',
        fontSizeXl: '20px',
        lineHeightTight: 1.2,
        lineHeightDefault: 1.45,
        lineHeightLoose: 1.6
    },
    spacing: {
        none: '0px',
        2: '2px',
        4: '4px',
        6: '6px',
        8: '8px',
        12: '12px',
        16: '16px',
        20: '20px',
        24: '24px',
        32: '32px',
        40: '40px'
    },
    radius: {
        sm: '6px',
        md: '10px',
        lg: '16px',
        xl: '24px',
        pill: '999px'
    },
    shadow: {
        sm: '0 4px 16px rgba(2, 6, 23, 0.18)',
        md: '0 16px 40px rgba(2, 6, 23, 0.32)'
    },
    elevation: {
        overlay: 1600,
        modal: 2000,
        toast: 2100
    }
};

const tokenVariableMap = {
    color: {
        background: '--ds-color-background',
        surface0: '--ds-color-surface-0',
        surface1: '--ds-color-surface-1',
        surface2: '--ds-color-surface-2',
        surface3: '--ds-color-surface-3',
        surfaceHighlight: '--ds-color-surface-highlight',
        borderSubtle: '--ds-color-border-subtle',
        borderStrong: '--ds-color-border-strong',
        textPrimary: '--ds-color-text-primary',
        textSecondary: '--ds-color-text-secondary',
        textMuted: '--ds-color-text-muted',
        accent: '--ds-color-accent',
        accentMuted: '--ds-color-accent-muted',
        accentContrast: '--ds-color-accent-contrast',
        focus: '--ds-color-focus',
        success: '--ds-color-success',
        warning: '--ds-color-warning',
        danger: '--ds-color-danger',
        overlay: '--ds-color-overlay'
    },
    typography: {
        fontFamily: '--ds-font-family-base',
        fontSizeXs: '--ds-font-size-xs',
        fontSizeSm: '--ds-font-size-sm',
        fontSizeMd: '--ds-font-size-md',
        fontSizeLg: '--ds-font-size-lg',
        fontSizeXl: '--ds-font-size-xl',
        lineHeightTight: '--ds-line-height-tight',
        lineHeightDefault: '--ds-line-height-default',
        lineHeightLoose: '--ds-line-height-loose'
    },
    spacing: {
        none: '--ds-space-none',
        2: '--ds-space-2',
        4: '--ds-space-4',
        6: '--ds-space-6',
        8: '--ds-space-8',
        12: '--ds-space-12',
        16: '--ds-space-16',
        20: '--ds-space-20',
        24: '--ds-space-24',
        32: '--ds-space-32',
        40: '--ds-space-40'
    },
    radius: {
        sm: '--ds-radius-sm',
        md: '--ds-radius-md',
        lg: '--ds-radius-lg',
        xl: '--ds-radius-xl',
        pill: '--ds-radius-pill'
    },
    shadow: {
        sm: '--ds-shadow-sm',
        md: '--ds-shadow-md'
    },
    elevation: {
        overlay: '--ds-elevation-overlay',
        modal: '--ds-elevation-modal',
        toast: '--ds-elevation-toast'
    }
};

export function applyDesignTokens(root = document.documentElement, overrides = {}) {
    const baseClone =
        typeof structuredClone === 'function'
            ? structuredClone(designTokens)
            : JSON.parse(JSON.stringify(designTokens));
    const merged = baseClone;

    Object.keys(overrides).forEach((category) => {
        if (!merged[category]) return;
        merged[category] = { ...merged[category], ...overrides[category] };
    });

    Object.entries(tokenVariableMap).forEach(([category, variables]) => {
        Object.entries(variables).forEach(([tokenKey, cssVariable]) => {
            const value = merged[category][tokenKey];
            if (typeof value !== 'undefined') {
                root.style.setProperty(cssVariable, value);
            }
        });
    });

    return merged;
}

export function withDesignTokens(overrides = {}) {
    return applyDesignTokens(document.documentElement, overrides);
}
